import React from 'react';

function UploadProducts({
    selectedVendorForUpload,
    setSelectedVendorForUpload,
    vendors,
    handleMultipleImageUpload,
    multipleFileInputRef // Ref passed from App.js
}) {
    return (
        <div className="mb-8 p-4 border rounded-md bg-gray-50 shadow-sm">
            <h2 className="text-2xl font-semibold mb-4 text-gray-800">Upload Products</h2>
            <div className="mb-4">
                <label htmlFor="selectedVendorForUpload" className="block text-sm font-medium text-gray-700 mb-1">
                    Select Vendor:
                </label>
                <select
                    id="selectedVendorForUpload"
                    value={selectedVendorForUpload}
                    onChange={(e) => setSelectedVendorForUpload(e.target.value)}
                    className="p-2 border border-gray-300 rounded-md w-full focus:ring-blue-500 focus:border-blue-500"
                >
                    <option value="">-- Select a Vendor --</option>
                    {vendors.map(vendor => (
                        <option key={vendor.vendor_id} value={vendor.vendor_name}>
                            {vendor.vendor_name}
                        </option>
                    ))}
                </select>
            </div>
            <div className="flex flex-col md:flex-row gap-4">
                <div className="flex-1">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Upload Images:</label>
                    <input
                        type="file"
                        ref={multipleFileInputRef} // Assign the ref here
                        onChange={handleMultipleImageUpload}
                        accept="image/*"
                        multiple
                        className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                    />
                    <p className="text-sm text-gray-500 mt-2">Select one or more image files.</p>
                </div>
            </div>
        </div>
    );
}

export default UploadProducts;
